















































































































































import Vue, { VNode } from "vue";
import { sha1 } from "object-hash";
export default Vue.extend({
  name: "IframeDialog",
  props: { visible: Boolean, autor: String },
  data() {
    return {
      initialized: false,
      signaturePad: null,
      messageHandler: function() {
        /** */
      },
      messageHashTimes: {} as { [key: string]: number },
    };
  },
  created() {
    this.messageHandler = this.onMessage.bind(this) as () => void;
    window.addEventListener("message", this.messageHandler, false);
  },
  destroyed() {
    window.removeEventListener("message", this.messageHandler);
  },
  methods: {
    onMessage(messageEvent: any) {
      if (!this.visible) {
        console.debug("Messages für verborgene Dialoge verhindert");
      }
      const targetOrigin =
        window.location.protocol + "//" + window.location.host;
      if (targetOrigin !== messageEvent.origin) {
        console.error("Fremde Message empfangen");
        console.error(messageEvent);
        return;
      }
      if (
        typeof messageEvent == "object" &&
        messageEvent.data &&
        typeof messageEvent.data == "object"
      ) {
        if (
          messageEvent.data.messageSource == "AUGURY_INSPECTED_APPLICATION" ||
          messageEvent.data.type == "webpackWarnings" ||
          messageEvent.data.type == "webpackInvalid" ||
          messageEvent.data.type == "webpackClose" ||
          messageEvent.data.command
        ) {
          return;
        }
        const hash = sha1(messageEvent.data);
        if (
          this.messageHashTimes[hash] &&
          this.messageHashTimes[hash] > new Date().getTime() - 2000
        ) {
          console.log("Bekannte Message verworfen");
          return;
        }
        this.messageHashTimes[hash] = new Date().getTime();
        console.log(messageEvent.data);
        console.log(typeof messageEvent.data.event);
        if (typeof messageEvent.data.event == "string") {
          messageEvent.cancelBubble = true;
          console.log("Emittiere " + messageEvent.data.event);
          /*
          const param = Object.assign({}, messageEvent.data.data, {sourceWindow: messageEvent.source});
          this.$emit(messageEvent.data.event, param);
          */
          this.$emit(messageEvent.data.event, messageEvent.data.data);
        }
      }
    },
    sendToIframe(event: any) {
      if (!this.visible) {
        console.error(
          "Es sollten keine Commands an unsichtbare Dialog-Frames gesendet werden!"
        );
        return;
      }
      console.log(event);
      const targetOrigin =
        window.location.protocol + "//" + window.location.host;
      (this.$refs.frame as any).contentWindow.postMessage(event, targetOrigin);
    },
  },
});
